var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SignLog',{attrs:{"form-name":'Register',"emailAdd":_vm.emailAdd,"token":_vm.token}})
}
var staticRenderFns = []

export { render, staticRenderFns }